import { clearAuth } from './authHelper';
import { isPublicStatusBrowseContext } from './publicStatusPage';

const isApiRequest = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.startsWith('/api/');
  } catch {
    return url.startsWith('/api/');
  }
};

/**
 * Wrapper around fetch that handles authentication errors globally
 * 
 * @param {string} url - The URL to fetch
 * @param {Object} options - Fetch options (headers, method, body, etc.)
 * @returns {Promise<Response>} - The fetch response
 * 
 * @example
 * const response = await authenticatedFetch('/api/chat/messages', {
 *   method: 'GET'
 * });
 */
export const authenticatedFetch = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);
    const isApiAuthFailure = isApiRequest(url);
    
    // Check for authentication errors
    if ((response.status === 401 || response.status === 403) && isApiAuthFailure) {
      const currentPath = window.location.pathname;
      
      if (!currentPath.startsWith('/auth') &&
          !currentPath.startsWith('/invitation') &&
          !isPublicStatusBrowseContext()) {
        
        console.log('🔒 Authentication error detected in fetch, clearing auth and redirecting to login');
        
        // Clear all auth data
        clearAuth();
        
        // Redirect to login page
        window.location.href = '/auth/login';
      }
    }
    
    return response;
  } catch (error) {
    // Re-throw network errors or other issues
    throw error;
  }
};

/**
 * Helper to get authentication headers
 * @returns {Object} Headers object with authorization token
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export default authenticatedFetch;
